import { PremiumReceivablesAgentRecord } from "entities/UIModel/PremiumReceivablesAgentRecord";

export const SAMPLE_AGENT_RECORDS: PremiumReceivablesAgentRecord[] = [
  {
    uniqueIdentifier: "AG-54321",
    agentID: "54321",
    name: "Lone Star Title Agency",
    division: "Southwest",
    region: "South Central",
    district: "42",
    state: "TX",
    officeType: "Direct Operations",
    remitPct: 70,
    beginBal: 12500.00,
    totalDebit: 8475.50,
    totalCredit: -6200.00,
    balance: 14775.50,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-12345",
    agentID: "12345",
    name: "Sunshine State Title Services",
    division: "Southeast",
    region: "Atlantic",
    district: "18",
    state: "FL",
    officeType: "Issuing Agent",
    remitPct: 75,
    beginBal: 8200.00,
    totalDebit: 3150.00,
    totalCredit: -9800.00,
    balance: 1550.00,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-67890",
    agentID: "67890",
    name: "Empire Title Group LLC",
    division: "Northeast",
    region: "Mid-Atlantic",
    district: "07",
    state: "NY",
    officeType: "Issuing Agent",
    remitPct: 80,
    beginBal: 22400.00,
    totalDebit: 15600.00,
    totalCredit: -18750.00,
    balance: 19250.00,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-99887",
    agentID: "99887",
    name: "Pacific Coast Title Partners",
    division: "West",
    region: "Pacific",
    district: "55",
    state: "CA",
    officeType: "Issuing Agent",
    remitPct: 72,
    beginBal: 5600.00,
    totalDebit: 9800.00,
    totalCredit: -12100.00,
    balance: 3300.00,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-33210",
    agentID: "33210",
    name: "Heartland Title & Escrow",
    division: "Central",
    region: "Great Lakes",
    district: "31",
    state: "IL",
    officeType: "Direct Operations",
    remitPct: 68,
    beginBal: 3100.00,
    totalDebit: 2250.00,
    totalCredit: -4500.00,
    balance: 850.00,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-77654",
    agentID: "77654",
    name: "Rocky Mountain Abstract Co.",
    division: "West",
    region: "Mountain",
    district: "50",
    state: "CO",
    officeType: "Issuing Agent",
    remitPct: 74,
    beginBal: 0,
    totalDebit: 4200.00,
    totalCredit: -4200.00,
    balance: 0,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-22100",
    agentID: "22100",
    name: "Southern Heritage Title",
    division: "Southeast",
    region: "Gulf",
    district: "22",
    state: "GA",
    officeType: "Issuing Agent",
    remitPct: 71,
    beginBal: 1800.00,
    totalDebit: 0,
    totalCredit: -3200.00,
    balance: -1400.00,
    isCancelled: false,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-44550",
    agentID: "44550",
    name: "Great Plains Title Services",
    division: "Central",
    region: "Plains",
    district: "35",
    state: "KS",
    officeType: "Non-Issuing Agent",
    remitPct: 65,
    beginBal: 600.00,
    totalDebit: 0,
    totalCredit: 0,
    balance: 600.00,
    isCancelled: false,
    isNonIssuing: true,
  },
  {
    uniqueIdentifier: "AG-88900",
    agentID: "88900",
    name: "Bay Area Title Corp (CANCELLED)",
    division: "West",
    region: "Pacific",
    district: "55",
    state: "CA",
    officeType: "Issuing Agent",
    remitPct: 70,
    beginBal: 4500.00,
    totalDebit: 0,
    totalCredit: 0,
    balance: 4500.00,
    isCancelled: true,
    isNonIssuing: false,
  },
  {
    uniqueIdentifier: "AG-11223",
    agentID: "11223",
    name: "Liberty Title Associates",
    division: "Northeast",
    region: "New England",
    district: "03",
    state: "MA",
    officeType: "Issuing Agent",
    remitPct: 78,
    beginBal: 9100.00,
    totalDebit: 6800.00,
    totalCredit: -14200.00,
    balance: 1700.00,
    isCancelled: false,
    isNonIssuing: false,
  },
];
